/* AdmShines theme behaviour — vanilla port of the design-system kit interactions.
   Cart uses Shopify AJAX API (/cart/add.js, /cart.js). No framework. */
(function () {
  'use strict';

  /* ---- Lucide icons ---- */
  function icons() { if (window.lucide && window.lucide.createIcons) window.lucide.createIcons(); }
  document.addEventListener('DOMContentLoaded', icons);
  window.addEventListener('load', icons);

  const money = (cents) =>
    (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.AdmShines && window.AdmShines.moneyFormat)
      : (cents / 100).toFixed(2).replace('.', ',') + ' €';

  /* ---- Toast ---- */
  let toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.querySelector('[data-adm-toast]');
      if (!toastEl) return;
    }
    const label = toastEl.querySelector('[data-adm-toast-label]');
    if (label && msg) label.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 2200);
  }

  /* ---- Cart count ---- */
  function setCartCount(n) {
    document.querySelectorAll('[data-adm-cart-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = n <= 0;
    });
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then((r) => r.json())
      .then((c) => setCartCount(c.item_count))
      .catch(() => {});
  }

  /* ---- AJAX add to cart (forms + buttons with data-adm-add) ---- */
  function addToCart(payload, successMsg) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) { toast(data.description || 'Klaida'); return; }
        refreshCart();
        toast(successMsg || 'Įdėta į krepšelį');
        document.dispatchEvent(new CustomEvent('adm:cart:added', { detail: data }));
      })
      .catch(() => toast('Tinklo klaida'));
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-adm-add-form]');
    if (!form) return;
    e.preventDefault();
    const id = form.querySelector('[name="id"]').value;
    const qtyEl = form.querySelector('[name="quantity"]');
    const qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    addToCart({ items: [{ id: Number(id), quantity: qty }] }, form.getAttribute('data-success'));
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-adm-add]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.getAttribute('data-adm-add');
    if (!id) return;
    addToCart({ items: [{ id: Number(id), quantity: 1 }] }, btn.getAttribute('data-success'));
  });

  /* ---- "Pirkti dabar" (add to cart, then go to the cart page) ---- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-adm-buynow]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const form = btn.closest('form');
    let id, qty = 1;
    if (form && form.querySelector('[name="id"]')) {
      id = form.querySelector('[name="id"]').value;
      const qtyEl = form.querySelector('[name="quantity"]');
      qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    } else {
      /* standalone buy-now (e.g. hero button): variant id lives on the attribute */
      id = btn.getAttribute('data-adm-buynow');
    }
    if (!id) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }),
    }).then((r) => { if (r.ok) window.location.href = '/cart'; else toast('Klaida'); })
      .catch(() => toast('Tinklo klaida'));
  });

  /* ---- TikTok clip muted-autoplay preview (GIF-like), only while in view ---- */
  const clipIO = ('IntersectionObserver' in window) ? new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      const v = en.target;
      if (en.isIntersecting) {
        if (v.dataset.userPlaying !== '1') { v.muted = true; const p = v.play(); if (p && p.catch) p.catch(() => {}); }
      } else if (v.dataset.userPlaying !== '1') {
        v.pause();
      }
    });
  }, { threshold: 0.25 }) : null;
  function initClipVideos(scope) {
    (scope || document).querySelectorAll('[data-adm-clip-video]').forEach((v) => {
      if (v.dataset.ioBound) return;
      v.dataset.ioBound = '1';
      v.muted = true; v.loop = true; v.playsInline = true;
      if (clipIO) clipIO.observe(v);
      else { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
    });
  }
  document.addEventListener('DOMContentLoaded', () => initClipVideos());

  /* ---- TikTok clip play (hosted video file or external embed) ---- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-adm-clip-play]');
    if (!btn) return;
    const card = btn.closest('[data-adm-clip]');
    if (!card) return;
    const type = btn.getAttribute('data-play');
    if (type === 'hosted') {
      const v = card.querySelector('.adm-clip__video');
      if (v) {
        v.muted = false;
        v.dataset.userPlaying = '1';
        v.setAttribute('controls', 'controls');
        card.classList.add('is-playing');
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      }
    } else if (type === 'embed') {
      const media = card.querySelector('.adm-clip__media');
      const url = btn.getAttribute('data-embed');
      if (media && url) {
        media.insertAdjacentHTML('beforeend',
          '<iframe class="adm-clip__iframe" src="' + url + '" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen></iframe>');
        card.classList.add('is-playing');
      }
    }
  });

  /* ---- Cart line quantity change / remove (AJAX) ---- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-change]');
    if (!btn || btn.dataset.busy) return;
    e.preventDefault();
    btn.dataset.busy = '1';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: btn.getAttribute('data-key'), quantity: parseInt(btn.getAttribute('data-qty'), 10) }),
    })
      .then((r) => r.json())
      .then(() => { window.location.reload(); })
      .catch(() => { btn.dataset.busy = ''; toast('Klaida'); });
  });

  /* ---- Cart business details (rekvizitai) toggle + save as cart attributes ---- */
  (() => {
    const wrap = document.querySelector('[data-cart-biz]');
    if (!wrap) return;
    const toggle = wrap.querySelector('[data-biz-toggle]');
    const fields = wrap.querySelector('[data-biz-fields]');
    const inputs = wrap.querySelectorAll('[data-biz-input]');
    let timer;

    const save = () => {
      const attributes = {};
      inputs.forEach((i) => {
        const key = i.getAttribute('name').replace(/^attributes\[|\]$/g, '');
        attributes[key] = toggle.checked ? i.value.trim() : '';
      });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes }),
      }).catch(() => {});
    };

    toggle.addEventListener('change', () => {
      fields.style.display = toggle.checked ? 'grid' : 'none';
      if (!toggle.checked) inputs.forEach((i) => { i.value = ''; });
      save();
    });

    inputs.forEach((i) => {
      i.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(save, 500); });
      i.addEventListener('blur', () => { clearTimeout(timer); save(); });
    });
  })();

  /* ---- Pack carousel scroll buttons ---- */
  document.addEventListener('click', (e) => {
    const nav = e.target.closest('[data-adm-scroll]');
    if (!nav) return;
    const dir = nav.getAttribute('data-adm-scroll') === 'next' ? 1 : -1;
    const scroller = document.querySelector(nav.getAttribute('data-target'));
    if (scroller) scroller.scrollBy({ left: dir * 320, behavior: 'smooth' });
  });

  /* ---- Quantity stepper ---- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-adm-qty]');
    if (!btn) return;
    const wrap = btn.closest('.adm-qty');
    const input = wrap.querySelector('[data-adm-qty-input]');
    const min = parseInt(input.getAttribute('min'), 10) || 1;
    const max = parseInt(input.getAttribute('max'), 10) || 99;
    let v = parseInt(input.value, 10) || min;
    v += btn.getAttribute('data-adm-qty') === 'inc' ? 1 : -1;
    v = Math.max(min, Math.min(max, v));
    input.value = v;
    wrap.querySelectorAll('[data-adm-qty]').forEach((b) => {
      b.disabled = (b.getAttribute('data-adm-qty') === 'dec' && v <= min) ||
                   (b.getAttribute('data-adm-qty') === 'inc' && v >= max);
    });
  });

  /* ---- Accordion (animated height like the kit) ---- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.adm-acc__btn');
    if (!btn) return;
    const item = btn.closest('.adm-acc__item');
    const acc = item.closest('.adm-acc');
    const panel = item.querySelector('.adm-acc__panel');
    const inner = panel.querySelector('.adm-acc__inner');
    const isOpen = item.classList.contains('adm-acc__item--open');
    if (!acc.hasAttribute('data-multiple')) {
      acc.querySelectorAll('.adm-acc__item--open').forEach((it) => {
        if (it !== item) {
          it.classList.remove('adm-acc__item--open');
          it.querySelector('.adm-acc__panel').style.height = '0px';
          it.querySelector('.adm-acc__btn').setAttribute('aria-expanded', 'false');
        }
      });
    }
    if (isOpen) {
      item.classList.remove('adm-acc__item--open');
      panel.style.height = '0px';
      btn.setAttribute('aria-expanded', 'false');
    } else {
      item.classList.add('adm-acc__item--open');
      panel.style.height = inner.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
    }
  });
  // init: open items flagged data-open
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.adm-acc__item--open').forEach((it) => {
      const p = it.querySelector('.adm-acc__panel');
      const inner = p.querySelector('.adm-acc__inner');
      p.style.height = inner.scrollHeight + 'px';
    });
  });

  /* ---- Before / After slider ---- */
  function initBeforeAfter(el) {
    let dragging = false;
    const setSplit = (clientX) => {
      const r = el.getBoundingClientRect();
      const pct = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
      el.style.setProperty('--split', pct + '%');
    };
    const start = (e) => { dragging = true; setSplit(e.touches ? e.touches[0].clientX : e.clientX); };
    const move = (e) => { if (dragging) setSplit(e.touches ? e.touches[0].clientX : e.clientX); };
    const end = () => { dragging = false; };
    el.addEventListener('mousedown', start);
    el.addEventListener('touchstart', start, { passive: true });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', end);
    window.addEventListener('touchend', end);
  }
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-adm-beforeafter]').forEach(initBeforeAfter);
  });

  /* ---- PDP gallery ---- */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-adm-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-adm-gallery]');
    const main = gallery.querySelector('[data-adm-gallery-main]');
    const src = thumb.getAttribute('data-src');
    if (main && src) main.src = src;
    gallery.querySelectorAll('[data-adm-thumb]').forEach((t) => t.setAttribute('aria-current', t === thumb ? 'true' : 'false'));
  });

  /* ---- PDP variant pills (updates hidden id + price) ---- */
  document.addEventListener('click', (e) => {
    const pill = e.target.closest('[data-adm-variant]');
    if (!pill) return;
    const root = pill.closest('[data-adm-product]');
    root.querySelectorAll('[data-adm-variant]').forEach((p) => p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'));
    const idInput = root.querySelector('[name="id"]');
    if (idInput) idInput.value = pill.getAttribute('data-variant-id');
    const priceEl = root.querySelector('[data-adm-price]');
    if (priceEl && pill.getAttribute('data-price')) priceEl.textContent = pill.getAttribute('data-price');
    const oldEl = root.querySelector('[data-adm-price-old]');
    if (oldEl) {
      const op = pill.getAttribute('data-price-old');
      if (op) { oldEl.textContent = op; oldEl.style.display = ''; } else { oldEl.style.display = 'none'; }
    }
  });

  /* init cart count on load */
  document.addEventListener('DOMContentLoaded', refreshCart);

  /* ---- Mobile: let the red promo bar scroll away, keep the nav bar sticky ----
     Offset the sticky wrapper up by the promo height so only the nav bar pins. */
  function admStickyOffset() {
    const wrap = document.querySelector('.adm-sticky-top');
    if (!wrap) return;
    const promo = wrap.querySelector('.adm-promo');
    let hidden = 0;
    if (promo && window.matchMedia('(max-width: 990px)').matches) {
      hidden = Math.ceil(promo.getBoundingClientRect().height);
      wrap.style.top = '-' + hidden + 'px';
    } else {
      wrap.style.top = '0px';
    }
    /* How much the sticky header actually covers. Anchor links (#duk, #results)
       offset by this so section headings don't land under the header. */
    const covered = Math.ceil(wrap.getBoundingClientRect().height) - hidden;
    document.documentElement.style.setProperty('--adm-sticky-h', covered + 'px');
  }
  document.addEventListener('DOMContentLoaded', admStickyOffset);
  window.addEventListener('load', admStickyOffset);
  window.addEventListener('resize', admStickyOffset);

  /* ---- Shopify theme editor: redraw icons + re-init interactions on re-render ----
     The editor swaps section HTML when a setting changes, which wipes the Lucide
     SVGs and the JS-driven components. Re-run them so icons don't disappear. */
  function reinit(scope) {
    icons();
    admStickyOffset();
    initClipVideos(scope);
    (scope || document).querySelectorAll('[data-adm-beforeafter]').forEach(initBeforeAfter);
    (scope || document).querySelectorAll('.adm-acc__item--open .adm-acc__panel').forEach((p) => {
      const inner = p.querySelector('.adm-acc__inner');
      if (inner) p.style.height = inner.scrollHeight + 'px';
    });
  }
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => reinit(e.target));
    document.addEventListener('shopify:section:select', () => icons());
    document.addEventListener('shopify:block:select', () => icons());
    document.addEventListener('shopify:block:deselect', () => icons());
  }
  // Safety net: redraw icons shortly after load in case the CDN script lands late.
  window.addEventListener('load', () => setTimeout(icons, 300));
})();

  /* ---- language dropdown: close on outside click ---- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-adm-langdd][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
